import React from "react";

const CTA = () => {
  return (
    <section className="cta">
      <div className="cta-left">
        <h2>Besoin d’une enseigne sur mesure ?</h2>
        <p>Nous sommes là pour vous !</p>
        <button className="btn-primary">Contacter Nous !</button>
      </div>

      <div className="cta-right">
        <h3>Bienvenue</h3>
        <p>+216 27 110 822</p>
      </div>
    </section>
  );
};

export default CTA;